import styled from 'styled-components';

export const MainNav = styled.div`
  display: grid;
  grid-area: mainNav;
  grid-template-areas:
    'mainheader'
    'mainmenu'
    'mainfooter';
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 46px;
  background-color: ${({ theme }) => theme.vars.newColor.darkGS1};
  color: ${({ theme }) => theme.vars.newColor.white};
  margin-bottom: 0px;
  left: 0px;
  height: 100vh;
  overflow: hidden;
`;

export const MainNavHeader = styled.div`
  grid-area: mainheader;
`;

export const MainNavMenu = styled.div`
  grid-area: mainmenu;

  a {
    display: block;
    text-decoration: none;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
    }
  }
`;

export const MainNavFooter = styled.div`
  grid-area: mainfooter;
`;

export const MainNavLogoSection = styled.div`
  display: flex;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.vars.newColor.blue2};
  }
`;

export const LogoImageElement = styled.img`
  display: flex;
  height: 32px;
  padding: 6px;
`;
